import { makeAutoObservable } from 'mobx'
import DisposableReactionsStore from 'reusable/mobx-store-utils/DisposableReactionsStore'
import { IStoreWithReactions } from 'reusable/mobx-store-utils/useStore'
import { AppBarContainerWithDrawerProps } from './AppBarContainerWithDrawer'

type ParamsProps = AppBarContainerWithDrawerProps & {
   bigScreen: boolean
   initialDrawerOpen?: boolean
}

export class AppBarContainerWithDrawerStore implements IStoreWithReactions {
   sp: ParamsProps
   open = false

   constructor(sp: ParamsProps) {
      this.sp = sp
      this.sp.setStore && this.sp.setStore(this)
      makeAutoObservable(this)
   }

   configureReactions = (reactionsStore: DisposableReactionsStore) => {
      reactionsStore.registerAutorun({
         observer: () => {
            if (this.sp.initialDrawerOpen !== undefined) {
               this.setOpen(this.sp.initialDrawerOpen)
            }
         },
      })
      reactionsStore.registerAutorun({
         observer: () => {
            if (this.sp.bigScreen) {
               this.setBigScreen(true)
            } else {
               this.setBigScreen(false)
            }
         },
      })
   }



   setBigScreen = (big: boolean) => {
      this.setOpen(big)
   }

   setOpen = (open: boolean) => (this.open = open)
   onClose = () => (this.open = false)
   drawerToggle = () => (this.open = !this.open)
}
